import { CheckCircle2 } from "lucide-react";
import { Reveal } from "@/lib/motion";
import { SectionHeading, Overline } from "@/components/ui-kit";
import LeadForm from "@/components/LeadForm";
import { useSeo } from "@/lib/useSeo";

const PERKS = [
  "Complimentary 45-minute design consultation",
  "Transparent budget and BOQ guidance",
  "Meet your dedicated Relationship Manager",
  "No obligation, no pressure",
];

export default function BookConsultation() {
  useSeo({ title: "Book Consultation", description: "Book a complimentary luxury interior design consultation with Sutra Interio, Kolkata." });
  return (
    <div data-testid="book-consultation-page" className="pt-32 md:pt-40 pb-24">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10 grid lg:grid-cols-12 gap-14 items-start">
        <div className="lg:col-span-5 lg:sticky lg:top-32">
          <Overline>Complimentary</Overline>
          <h1 className="font-display text-5xl md:text-7xl leading-[1.02] mt-4">Book a <span className="italic text-bronze">consultation.</span></h1>
          <p className="mt-6 text-lg text-ink/70 leading-relaxed">Pick a date and time that suits you. Our team will confirm your appointment and prepare for a productive first conversation.</p>
          <div className="mt-8 space-y-4">
            {PERKS.map((p, i) => (
              <Reveal key={p} delay={i * 0.06} className="flex gap-3 items-start">
                <CheckCircle2 className="text-bronze shrink-0 mt-0.5" size={20} />
                <span className="text-ink/80">{p}</span>
              </Reveal>
            ))}
          </div>
          <div className="mt-10 border-t border-gold/20 pt-8">
            <SectionHeading title="120+ homes" italic="delivered." />
            <p className="text-ink/60 mt-3 text-sm">Join families across Kolkata who chose a calmer, more transparent way to design their homes.</p>
          </div>
        </div>

        <div className="lg:col-span-7">
          <Reveal className="bg-cream border border-gold/20 rounded-lg p-8 md:p-12">
            <h3 className="font-display text-3xl mb-6">Request your appointment</h3>
            <LeadForm variant="full" showDateTime source="Consultation Booking" />
          </Reveal>
        </div>
      </div>
    </div>
  );
}
